import * as React from 'react';

export type PresenceContextValue = {
  hardwareMembers: Set<string>;
};

export const PresenceContext = React.createContext<PresenceContextValue>({
  hardwareMembers: new Set(),
});
